/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MoneyWalletAIcon16Solid = forwardRef('MoneyWalletAIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M1 3.5A2.5 2.5 0 0 1 3.5 1h6a2.5 2.5 0 0 1 2.45 2H3.5a.5.5 0 0 0 0 1h9a2.5 2.5 0 0 1 2.45 2H10.5a2.5 2.5 0 0 0 0 5H15v.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 11.5v-8Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 10h-4.5a1.5 1.5 0 1 1 0-3H15v3Zm-3-1.468a.7.7 0 1 1-1.4 0 .7.7 0 0 1 1.4 0Z" })));
});
